import { setServerUrl, getUseAPIFrontend, getAPIFrontend, setHeaders } from "typed-client-server-api/hooks";
import { API } from "../../types";

if (process.env.NODE_ENV === "development") {
    const PORT = process.env.PORT_SERVER;
    setServerUrl("http://localhost:" + PORT);
}

let authorization = "";

setHeaders(() => ({
    "Content-Type": "application/json",
    "Authorization": authorization,
}));

export function setAuthorizationHeader(newAuthorization: string) {
    authorization = newAuthorization;
}

export const api = getAPIFrontend<API>();
export const useApi = getUseAPIFrontend<API>();